export function getEmailTemplates(all = '', callback) {
  if(all === true) {
    all = 'all';
  }
  return simpleIsoFetch => () =>
    simpleIsoFetch.get(`/api/admin/emails/${all}`)
      .then(({body: {data: {items: templates}}}) => {
        if(callback) {
          return callback(null, templates);
        }
        return templates;
      })
      .catch(err => {
        if(callback) {
          return callback(err);
        }
        return Promise.reject(err);
      });
}


export function createTemplate(body) {
  return simpleIsoFetch => () =>
    simpleIsoFetch.post({route: '/api/admin/emails/', body})
      .then(({body: {data: {items: templates}}}) => templates);
}

export function updateTemplate(id, body) {
  return simpleIsoFetch => () =>
    simpleIsoFetch.put({route: `/api/admin/emails/${id}`, body})
      .then(({body: {data: {items: templates}}}) => templates);
}

export function deleteTemplate(id) {
  return simpleIsoFetch => () =>
    simpleIsoFetch.del({route: `/api/admin/emails/${id}`})
      .then(({body: {data: {items: templates}}}) => templates);
}

export function sendEmail(to, cc, subject, html, attachments, callback) {
  return simpleIsoFetch => () => {
    simpleIsoFetch.post({
      route: '/api/admin/emails/send',
      body : {
        to,
        cc,
        subject,
        html,
        attachments
      }
    })
      .then(() => callback())
      .catch(err => {
        if(callback) {
          return callback(err);
        }
        return Promise.reject(err);
      });
  };
}

export function sendContactEmail(contactId, cc, subject, html, attachments, callback) {
  return simpleIsoFetch => () => {
    simpleIsoFetch.post({
      route: `/api/contacts/${contactId}/email`,
      body : {
        cc,
        subject,
        html,
        attachments
      }
    })
      .then(() => callback())
      .catch(err => {
        if(callback) {
          return callback(err);
        }
        return Promise.reject(err);
      });
  };
}




// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/emails.js